import { COPY_URL_LINK, SHARE } from 'NewAngular/constants/core.constants';
/*
 * Fund Screener Constants
 */
export const FUND_SCREENER_APP_STATE_SLICE_KEY = 'fundScreener';
// Fund Screener Identifiers
export const FUND_SCREENER_IDENTIFIER = 'fund';
export const FUND_SCREENER_METRIC_TYPE = 'fund';
export const FUND_SCREENER_INFO_TYPE = 'fund';
export const FUND_SCREENER_TYPE_LABEL = 'Fund';
// Fund Screener Plural Identifier
export const FUNDS = 'Funds';
export const SAVED_FUND_SCREEN_STATE_KEYS = [
    'exposureFilters',
    'metricFilters',
    'onlyPrimaryShares',
    'orderedColumns',
    'pinnedSecurityIds',
    'securitylistFilters',
    'sort',
    'sortDirection',
];
export const FUND_SCREENER_STATE_KEYS = [
    'exposureFilters',
    'metricFilters',
    'onlyPrimaryShares',
    'orderedColumns',
    'page',
    'pinnedSecurityIds',
    'screen',
    'securitylistFilters',
    'sort',
    'sortDirection',
];
/*
 * Stock Screener Constants
 */
export const STOCK_SCREENER_APP_STATE_SLICE_KEY = 'stockScreener';
// Stock Screener Identifiers
export const STOCK_SCREENER_IDENTIFIER = 'company';
export const STOCK_SCREENER_METRIC_TYPE = 'company';
export const STOCK_SCREENER_INFO_TYPE = 'company';
export const STOCK_SCREENER_TYPE_LABEL = 'Stock';
// Stock Screener Plural Identifier
export const EQUITIES = 'Equities';
export const SAVED_STOCK_SCREEN_STATE_KEYS = [
    'page',
    'metricFilters',
    'onlyPrimaryShares',
    'orderedColumns',
    'pinnedSecurityIds',
    'ratings',
    'securitylistFilters',
    'sort',
    'sortDirection',
];
export const STOCK_SCREENER_STATE_KEYS = [
    'metricFilters',
    'onlyPrimaryShares',
    'orderedColumns',
    'ratings',
    'page',
    'pinnedSecurityIds',
    'screen',
    'securitylistFilters',
    'sort',
    'sortDirection',
];
// Ratings Filters Constants
export const RATING_1_ATTRACTIVE = '1-attractive';
export const RATING_2_NEUTRAL = '2-neutral';
export const RATING_3_AVOID = '3-avoid';
export const RATING_4_UNRATED = '4-unrated';
/*
 * Shared Constants
 */
// Sharing options
export const SAVED_SCREEN_SHARING_OPTIONS = {
    title: {
        label: 'Share',
        icon: 'icon-share',
    },
    list: [
        {
            type: 'option',
            label: 'Share with Team',
            value: SHARE,
            icon: 'icon-team',
        },
        {
            type: 'divider',
            label: null,
            value: null,
            icon: null,
        },
        {
            type: 'option',
            label: 'Copy Link',
            value: COPY_URL_LINK,
            icon: 'icon-link',
        },
    ],
};
// Screener Data table column class name
export const SCREENER_COLUMN_DEFAULT_CSS_CLASS = 'colTxtShort';
// Metric filter comparisons
export const BETWEEN = 'between';
export const GREATER_THAN = 'greater_than';
export const GREATER_THAN_EQUAL = 'greater_than_equal';
export const LESS_THAN = 'less_than';
export const LESS_THAN_EQUAL = 'less_than_equal';
export const EQUAL = 'equal';
export const PERCENTILE_SEQUENTIAL = 'percentile_sequential';
export const PERCENTILE_UNIVERSE = 'percentile_universe';
export const RANK_SEQUENTIAL = 'rank_sequential';
export const RANK_UNIVERSE = 'rank_universe';
// metric label constants
export const MIDDLE_EXPRESSION_LABEL_MAP = {
    [BETWEEN]: '<>',
    [EQUAL]: '=',
    [GREATER_THAN]: '>',
    [GREATER_THAN_EQUAL]: '>=',
    [LESS_THAN]: '<',
    [LESS_THAN_EQUAL]: '<=',
    [PERCENTILE_SEQUENTIAL]: '%',
    [PERCENTILE_UNIVERSE]: '%',
};
export const PERCENTILE_OPERATORS = ['percentile_sequential', 'percentile_universe'];
export const RANK_OPERATORS = ['rank_sequential', 'rank_universe'];
/*
 * Metric Filter Modal constants
 */
export const TOKEN_IS_EDITING = '__TOKEN_IS_EDITING__';
export const INTEGER_REGEX_EXP = /^[0-9]+$/;
export const METRIC_FILTER_OPERATOR_REGEX = '^[\\*\\/\\+\\-\\^]$';
export const METRIC_FILTER_OPERATOR_REGEX_EXP = new RegExp(METRIC_FILTER_OPERATOR_REGEX);
export const METRIC_FILTER_PARENTHESES_REGEX_EXP = /^[()]$/;
export const METRIC_FILTER_NUMBER_REGEX = '^-?(\\d+\\.?\\d*|\\d*\\.?\\d+)(?:k|m|b|t|q|%|K|M|B|T|Q)?$';
export const METRIC_FILTER_NUMBER_REGEX_EXP = new RegExp(METRIC_FILTER_NUMBER_REGEX);
// joined both together.. could theoretically define this as the `{$operator}|{$number}`
export const METRIC_FILTER_SEARCH_BLOCK_REGEX = '-?(?:[0-9]*\\.[0-9]+|[0-9]+\\.?)(?:k|m|b|t|q|%|K|M|B|T|Q)?|^(\\*|\\/|\\+|\\-|\\^|\\(|\\))$';
export const METRIC_FILTER_PARTIAL_SIDE_LEFT = 'left';
export const METRIC_FILTER_PARTIAL_SIDE_RIGHT = 'right';
export const METRIC_FILTER_MODAL_TABS = {
    RANK: 'rank',
    EQUATION: 'equation',
    PERCENTILE: 'percentile',
    RANGE: 'range',
};
/*
 * Metric filter drop down values
 */
export const METRIC_FILTER_TOP_OR_BOTTOM_TOP = 'top';
export const METRIC_FILTER_TOP_OR_BOTTOM_BOTTOM = 'bottom';
export const METRIC_FILTER_TOP_OR_BOTTOM_VALUES = [METRIC_FILTER_TOP_OR_BOTTOM_TOP, METRIC_FILTER_TOP_OR_BOTTOM_BOTTOM];
export const METRIC_FILTER_ORDER_HIGHER_IS_BETTER = 'higher_value_is_better';
export const METRIC_FILTER_ORDER_LOWER_IS_BETTER = 'lower_value_is_better';
export const METRIC_FILTER_ORDER_VALUES = [METRIC_FILTER_ORDER_HIGHER_IS_BETTER, METRIC_FILTER_ORDER_LOWER_IS_BETTER];
export const METRIC_FILTER_QUANTILE_SIZE_PERCENTILE = 'percentile';
export const METRIC_FILTER_QUANTILE_SIZE_DECILE = 'decile';
export const METRIC_FILTER_QUANTILE_SIZE_QUINTILE = 'quintile';
export const METRIC_FILTER_QUANTILE_SIZE_QUARTILE = 'quartile';
export const METRIC_FILTER_QUANTILE_SIZE_VALUES = [
    METRIC_FILTER_QUANTILE_SIZE_PERCENTILE,
    METRIC_FILTER_QUANTILE_SIZE_DECILE,
    METRIC_FILTER_QUANTILE_SIZE_QUINTILE,
    METRIC_FILTER_QUANTILE_SIZE_QUARTILE,
];
export const METRIC_FILTER_QUANTILE_SIZE_INTEGER_MAP = {
    [METRIC_FILTER_QUANTILE_SIZE_PERCENTILE]: 100,
    [METRIC_FILTER_QUANTILE_SIZE_DECILE]: 10,
    [METRIC_FILTER_QUANTILE_SIZE_QUINTILE]: 5,
    [METRIC_FILTER_QUANTILE_SIZE_QUARTILE]: 4,
};
export const METRIC_FILTER_DEFAULT_ORDINAL_VALUE = '1';
